export default __webpack_public_path__ + "static/media/q18_02.1c8bcd0b.png";